/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type RecipientStatus =
    (typeof RecipientStatus)[keyof typeof RecipientStatus];

export const RecipientStatus = {
    Completed: 0,
    NoChange: 1,
    Failed: 2,
    Uncertain: 3,
} as const;
